import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ToastSuccess } from "../../common/Toast";
import { getToken } from "../../config";


const initialPasswordState = { isLoading: false, isError: "", updatePasswordRes: "" };

const updatePasswordSlice = createSlice({
    name: "updatePassword",
    initialState: initialPasswordState,
    reducers: {
        apiCallRequested(state) {
            state.isLoading = true;
            state.isError = "";
        },
        apiCallSuccess(state, action) {
            state.isLoading = false;
            state.updatePasswordRes = action.payload;
        },
        apiCallFailed(state, action) {
            state.isLoading = false;
            state.isError = action.payload;
        },
    }
});


export const updatePasswordAPi = (data) => {
    return async (dispatch,getState) => {
        const token = getState()?.LoginRes?.authResToken;

        dispatch(updatePasswordActions.apiCallRequested());

        try {
            const res = await axios({
                method: "POST", url: `/tenant/change-password`, data, headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const { error, message } = res?.data;
            if (!error) {
                const { message } = res?.data?.data;
                dispatch(updatePasswordActions.apiCallSuccess(message));
                ToastSuccess(message)
            } else {
                throw message;
            }
        } catch (error) {
            dispatch(updatePasswordActions.apiCallFailed(error));
            console.log(error)
        }
    }
};


export const updatePasswordActions = updatePasswordSlice.actions;

export default updatePasswordSlice.reducer;